import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'
import getGroupedBidParamsFromUrl from '@/features/bidding/utils/groupedBidParams/getGroupedBidParamsFromUrl'

export type UseBidOfferGroupParamsReturn =
  | { isLoading: true; data: null }
  | { isLoading: false; data: GroupedBidParams }

export function useBidOfferGroupParams(): UseBidOfferGroupParamsReturn {
  const location = useLocation()
  const navigate = useNavigate()
  const groupParams = getGroupedBidParamsFromUrl(location)

  // Redirect to bidding page if no group params
  useEffect(() => {
    if (!groupParams) navigate('/bidding', { replace: true })
  }, [groupParams, navigate])

  if (!groupParams) {
    return { isLoading: true, data: null }
  }

  return { isLoading: false, data: groupParams }
}
